export default __webpack_public_path__ + "static/media/dark_badge.4bbf42f5.svg";